module.exports = __webpack_public_path__ + "media/images/countrysquared/qa-742e6032bc286ecf97b5161fe9f1bceb.svg";